import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { DxListModule, DxSelectBoxModule } from "devextreme-angular";
import { SelectCommonTeamComponent } from "./select-common-team/select-common-team.component";
import { SelectTeamsComponent } from "./select-teams/select-teams.component";
import { AdaptTeamDashboardSharedModule } from "./team-dashboard-shared/team-dashboard-shared.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DxSelectBoxModule,
        DxListModule,
        AdaptTeamDashboardSharedModule,
        AdaptTooltipModule,
    ],
    exports: [
        SelectCommonTeamComponent,
        SelectTeamsComponent,
    ],
    declarations: [
        SelectCommonTeamComponent,
        SelectTeamsComponent,
    ],
})
export class AdaptTeamsSharedModule { }
